import { Component, inject, OnInit } from '@angular/core';
import { ToastService } from '../../../core/services/app-toast.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [NgClass],
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
})
export class Toast implements OnInit {
  show = false;
  message = '';
  type = 'success';

  private readonly toastService = inject(ToastService);

  ngOnInit(): void {
    this.toastService.toastState$.subscribe((toast) => {
      this.message = toast.message;
      this.type = toast.type;
      this.show = true;

      setTimeout(() => {
        this.show = false;
      }, 3000);
    });
  }
}
